const actions = {
	SET_GROUP_INFORMATION: "SET_GROUP_INFORMATION",
	SET_LOCATION_INFORMATION: "SET_LOCATION_INFORMATION",
	SET_CURRENT_GROUP: "SET_CURRENT_GROUP"
};

export default actions;
